import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import List from "./List";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<List />} />
      <Route path=":certificateId" element={<List />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};
export default View;
